import { message } from 'antd';
import { saveFromLink } from '~src/utils/downloader/shared/saveFromLink';
import { DownloadingState, useStore } from '~src/store';
import {
  getSharedTenderVersionedFilesDownloadList,
  getTenderShareFolderFilesURLs,
} from '~src/services/api/shares';

export const downloadVendorTenderFolderFile = async ({
  shareId,
  shareKey,
  rootFolderId,
  folderId,
  registrationId,
  serialNumber,
  onDownloadStarted,
}: {
  shareId: string | number;
  shareKey: string;
  rootFolderId: string | number;
  folderId: string | number;
  registrationId: string | number;
  serialNumber?: string | number;
  onDownloadStarted?: () => void;
}) => {
  try {
    useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);

    const downloadList = await getSharedTenderVersionedFilesDownloadList({
      shareId,
      shareKey,
      rootFolderId,
      folderId,
      recursive: true,
      registration_ids: String(registrationId),
      skip: 0,
      serial: serialNumber,
    });

    if (!downloadList || downloadList.length === 0) {
      throw new Error('File not found for download');
    }

    const usingKey = downloadList[0].using_key;

    const urls = await getTenderShareFolderFilesURLs(
      String(shareId),
      shareKey,
      [usingKey]
    );

    if (!urls || urls.length === 0 || !urls[0].url) {
      throw new Error('URL not found');
    }

    if (onDownloadStarted) {
      onDownloadStarted();
    }

    saveFromLink(urls[0].url, downloadList[0].file_name);

    useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
    setTimeout(() => {
      useStore.getState().changeDownloadingActive(false);
    }, 3000);
  } catch (error) {
    console.error('downloadSingleSharedTenderFile -> err', error);
    useStore.getState().changeDownloadingActive(false);
    throw error;
  }
};
